<template>
  <div class="filter-bar">
    <div class="filter-bar__label">品类检索：</div>
    <a-select
      v-model:value="state.filterParams.firstCategoryId"
      style="width: 150px"
      placeholder="全部"
      allow-clear
      class="mr10"
      @change="state.onCategory1Change"
    >
      <a-select-option
        v-for="item in state.category1List"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      v-model:value="state.filterParams.secondCategoryId"
      style="width: 150px"
      placeholder="全部"
      allow-clear
      class="mr10"
      :disabled="!state.filterParams.firstCategoryId"
      @change="state.onCategory2Change"
    >
      <a-select-option
        v-for="item in state.category2List"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      v-model:value="state.filterParams.thirdCategoryId"
      style="width: 150px"
      placeholder="全部"
      allow-clear
      class="mr10"
      :disabled="!state.filterParams.secondCategoryId"
    >
      <a-select-option
        v-for="item in state.category3List"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-button type="primary" class="mr10" @click="state.handleSearch()">
      查询
    </a-button>
    <a class="filter-bar__reset" @click="state.handleResetFilter()">
      重置列表
    </a>
  </div>
</template>

<script>
import { inject } from 'vue'

export default {
  name: 'FilterBar',
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>

<style lang="scss" scoped>
.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__label {
    white-space: nowrap;
    margin-right: 8px;
  }

  &__reset {
    color: #999;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: #1890ff;
    }
  }
}
</style>
